import React from "react";
import { Field, reduxForm } from "redux-form";
import { Form, Button, Segment } from "semantic-ui-react";
import { LOADING } from "../utils/helpers/phases";

const EditUserComponent = props => {
  const { handleSubmit, t } = props;
  return (
    <Segment basic>
      <Form as="form" size="large" onSubmit={handleSubmit}>
        <Field
          name="firstname"
          type="text"
          component={Form.Input}
          fluid
          label={t("user:firstnameText")}
          placeholder={t("user:firstnameText")}
        />
        <Field
          name="surname"
          type="text"
          component={Form.Input}
          fluid
          label={t("user:surnameText")}
          placeholder={t("user:surnameText")}
        />
        <Button
          color="blue"
          type="submit"
          loading={props.phase === LOADING}
          disabled={props.phase === LOADING}>
          {t("common:updateText")}
        </Button>
      </Form>
    </Segment>
  );
};
export default reduxForm({
  form: "edit-user" // a unique name for this form
})(EditUserComponent);



// WEBPACK FOOTER //
// ./src/components/EditUserComponent.js